import Media from 'react-media';
import React from 'react';
import './ScoreCard.css';

class ScoreCard extends React.PureComponent {
  render() {
    const {scoreEdit} = this.props;
    let homeTeamAvatar = null;
    let homeTeamName = null;
    let homeTeamRecord = null;
    if (scoreEdit._embedded.home_team) {
      homeTeamAvatar = (
        <a className="FeedScoreCardTeam-avatar" href={scoreEdit._embedded.home_team._links.self.href}>
          <img src={scoreEdit._embedded.game._links.home_team_profile_picture.href} />
        </a>
      );
      if (scoreEdit._embedded.home_team.team_type === 'highschool' || scoreEdit._embedded.home_team.team_type === 'college') {
        homeTeamName = (
          <a className="FeedScoreCardTeam-name" href={scoreEdit._embedded.home_team._links.self.href}>
            {scoreEdit._embedded.home_team.school_name}
          </a>
        );
      } else {
        homeTeamName = (
          <a className="FeedScoreCardTeam-name" href={scoreEdit._embedded.home_team._links.self.href}>
            {scoreEdit._embedded.home_team.display_name}
          </a>
        );
      }
      if (scoreEdit.home_team_record) {
        homeTeamRecord = (
          <span  className="FeedScoreCardTeam-record">{' '}({scoreEdit.home_team_record})</span>
        );
      }
    } else {
      homeTeamAvatar = (
        <span className="FeedScoreCardTeam-avatar">
          <img src={scoreEdit._embedded.game._links.home_team_profile_picture.href} />
        </span>
      );
      homeTeamName = (
        <span className="FeedScoreCardTeam-name">
          {scoreEdit.home_team_name}
        </span>
      );
    }

    let awayTeamAvatar = null;
    let awayTeamName = null;
    let awayTeamRecord = null;
    if (scoreEdit._embedded.away_team) {
      awayTeamAvatar = (
        <a className="FeedScoreCardTeam-avatar" href={scoreEdit._embedded.away_team._links.self.href}>
          <img src={scoreEdit._embedded.game._links.away_team_profile_picture.href} />
        </a>
      );
      if (scoreEdit._embedded.away_team.team_type === 'highschool' || scoreEdit._embedded.away_team.team_type === 'college') {
        awayTeamName = (
          <a className="FeedScoreCardTeam-name" href={scoreEdit._embedded.away_team._links.self.href}>
            {scoreEdit._embedded.away_team.school_name}
          </a>
        );
      } else {
        awayTeamName = (
          <a className="FeedScoreCardTeam-name" href={scoreEdit._embedded.away_team._links.self.href}>
            {scoreEdit._embedded.away_team.display_name}
          </a>
        );
      }
      if (scoreEdit.away_team_record) {
        awayTeamRecord = (
          <span className="FeedScoreCardTeam-record">{' '}({scoreEdit.away_team_record})</span>
        );
      }
    } else {
      awayTeamAvatar = (
        <span className="FeedScoreCardTeam-avatar">
          <img src={scoreEdit._embedded.game._links.away_team_profile_picture.href} />
        </span>
      );
      awayTeamName = (
        <span className="FeedScoreCardTeam-name">
          {scoreEdit.away_team_name}
        </span>
      );
    }

    let leagueGroup = null;
    if (scoreEdit._links.away_league || scoreEdit._links.home_league) {
      let awayLeague = scoreEdit._links.away_league;
      let homeLeague = scoreEdit._links.home_league;
      if (awayLeague && homeLeague && awayLeague.href == homeLeague.href) {
        homeLeague = null;
      }
      leagueGroup = (
        <Media query="(min-width: 768px)">
          {
            matches => {
              return matches ? (
                <div className="FeedScoreCard-leagues clearfix text-right">
                  <div className="pull-left">
                    <img className="FeedScoreCard-leaguesIcon" src="/static/img/scoreboard.svg" />
                    <div className="btn-txt">
                      League Scoreboards
                    </div>
                  </div>
                  {
                    awayLeague ? (
                      <a className="btn btn-blue-outline FeedScoreCard-leagueBtn" href={awayLeague.href}>
                        {awayLeague.title}
                      </a>
                    ): null
                  }
                  {
                    homeLeague ? (
                      <a className="btn btn-blue-outline FeedScoreCard-leagueBtn" href={homeLeague.href}>
                        {homeLeague.title}
                      </a>
                    ): null
                  }
                </div>
              ): (
                <div className="FeedScoreCard-leagues" style={{textAlign: 'center'}}>
                  <div className="btn-txt">
                    <img className="FeedScoreCard-leaguesIconM "src="/static/img/scoreboard.svg" /> League Scoreboards
                  </div>
                  <div className="row">
                    {
                      awayLeague ? (
                        <div className="col-xs-6">
                          <a className="btn btn-blue-outline btn-block" href={awayLeague.href}>
                            {awayLeague.title}
                          </a>
                        </div>

                      ): null
                    }
                    {
                      homeLeague ? (
                        <div className="col-xs-6">
                          <a className="btn btn-blue-outline btn-block" href={homeLeague.href}>
                            {homeLeague.title}
                          </a>
                        </div>
                      ): null
                    }
                  </div>
                </div>
              );
            }
          }
        </Media>
      );
    }
    return (
      <div className="FeedScoreCard">
        <div className="FeedScoreCardRow">
          <div className="FeedScoreCardTeam">
            {awayTeamAvatar}
            <div className="FeedScoreCardTeam-details">
              {awayTeamName}
              <br />
              <div className="FeedScoreCardTeam-location">{scoreEdit._embedded.game.away_team_display_location}</div>
              {awayTeamRecord}
            </div>
            <div className="FeedScoreCardTeam-score">{scoreEdit.away_team_score}</div>
          </div>
        </div>

        <div className="FeedScoreCardRow">
          <div className="FeedScoreCardTeam">
            {homeTeamAvatar}
            <div className="FeedScoreCardTeam-details">
              {homeTeamName}
              <br />
              <div className="FeedScoreCardTeam-location">{scoreEdit._embedded.game.home_team_display_location}</div>
              {homeTeamRecord}
            </div>
            <div className="FeedScoreCardTeam-score">{scoreEdit.home_team_score}</div>
          </div>
        </div>

        <div className="FeedScoreCardMeta clearfix">
          <div className="FeedScoreCardMeta-extended">
            {
              scoreEdit.final ? (
                'Final'
              ): (
                scoreEdit.extended_info_summary
              )
            }
          </div>
          {scoreEdit._embedded.game.display_gender} {scoreEdit._embedded.game.level} {scoreEdit._embedded.game.sport.name}
        </div>

        {
          scoreEdit.notes ? (
            <div className="FeedScoreCard-notes">{scoreEdit.notes}</div>
          ): null
        }

        {leagueGroup}
      </div>
    );
  }
}

export default ScoreCard;
